import { useAuth, useUser } from "@clerk/react";

export default function usePaidPlan() {
  const { has, isLoaded } = useAuth();
  const { user } = useUser();
  const hasPaidPlan = (has?.({ plan: 'bidder_iq' }) ?? false) || user?.publicMetadata?.plan === 'bidder_iq';
  return { hasPaidPlan, isLoaded };
}
